export default __webpack_public_path__ + "static/media/fcb.9091cfec.jpg";